import {
  CLEAR_MCS_PLAY_BUTTON_LIST,
  CLEAR_SEARCH_RESULTS,
  GET_POPULAR_SEARCHES,
  GET_SEARCH_RESULTS,
  NOT_FOUND_SEARCH_RESULTS,
  SEARCH_ADD_BOOKMARK_LIVE,
  SEARCH_CLEAR_LIVE_MENU_OPTIONS,
  SET_LIVE_MENU_OPTIONS,
  SET_KEYWORD_SEARCH,
  CLEAR_KEYWORD_SEARCH,
  IS_LOADING_SEARCH,
  POPULAR_ADD_BOOKMARK_LIVE,
  SET_ERROR_SEARCH,
} from '../constants';
import {
  getMCSPlayButtonList,
  getPlayButtonListPopularSearches,
} from './multiContentSearch.actions';
import api from './../../../../services/api/microfwk';
import { getRegion } from 'utils/Region';
import { getSearchPredictive } from 'services/api/search/predictive';
import { SEARCH_LINEAL_PREDICTIVE } from 'api/services/content/paths';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';


//----UTILS----
//Obtiene los bookmarks de los contenidos
export const getBookmarks = async ({
  contenidos,
  user_hash,
  filterlist,
  lasttouch,
}) => {
  //ID`S DE LOS CONTENIDOS
  const group_id = contenidos?.map(item => item?.id).join(',');

  let bookmarkResponse = '';
  //BOOKMARK DE LOS CONTENIDOS
  try {
    bookmarkResponse = await api.get('services/user/getbookmark', {
      params: {
        api_version: 'v4',
        filter_list: filterlist,
        user_hash,
        group_id,
        lasttouch,
      },
    });
  } catch (error) {
    console.log('Getbookmark', error);
  }

  let searchResults;
  if (bookmarkResponse?.data?.response?.groups?.length) {
    searchResults = contenidos?.map(item => {
      const hasBookmark = bookmarkResponse?.data?.response?.groups?.find(
        bookmarkItem => bookmarkItem?.id === item?.id,
      );
      if (hasBookmark) {
        return {
          ...item,
          bookmark: hasBookmark?.vistime,
        };
      } else {
        return item;
      }
    });
  } else {
    searchResults = contenidos;
  }

  return searchResults;
};

//----Obtener los resultados de la busqueda, value hace referencia al valor capturado del input-----
export const getSearchResults = searchValues => async (dispatch, getState) => {
  const cv_advertising_config = getClaroAdsKey(getState());
  const {
    value,
    filterlist,
    user_hash,
    token,
    epg_version,
    quantity,
    is_kids,
  } = searchValues;

  dispatch({
    type: CLEAR_SEARCH_RESULTS,
  });
  dispatch({
    type: CLEAR_MCS_PLAY_BUTTON_LIST,
  });

  if (value.length === 0) return;

  try {
    //SETEAR EN TRUE EL IS LOADING
    dispatch({
      type: IS_LOADING_SEARCH,
      payload: true,
    });
    const params = {
      value,
      filterlist,
      quantity: quantity,
      epg_version,
      is_kids,
    }
    if(cv_advertising_config){
      params.url = SEARCH_LINEAL_PREDICTIVE;
      params.hasClaroAdActive = cv_advertising_config
    }else{
     params.api_version = 'v5.93',
     params.url = 'services/search/linealpredictive';
     params.hasClaroAdActive = cv_advertising_config || false
    }
    //RESULTADOS DE LA BUSQUEDA

    const { data: predictiveResponse } = await getSearchPredictive(params)

    //SETEAR EL ERROR
    if (predictiveResponse?.errors?.length > 0) {
      dispatch(setErrorLinealPredictive(predictiveResponse?.errors));
      //SE CREA EL ERROR CUANDO LA API RESPONDE CON 200
      if(is_kids === 1){
        const error = {error : {response: {data: {errors: predictiveResponse?.errors}} }}
        throw error
      }  
    }
    //SI NO SE ENCUENTRAN RESULTADOS
    if (
      predictiveResponse?.response?.contenidos?.length === 0 &&
      predictiveResponse?.response?.talentos?.length === 0
    ) {
      dispatch({
        type: IS_LOADING_SEARCH,
        payload: false,
      });

      return dispatch({
        type: NOT_FOUND_SEARCH_RESULTS,
        payload: { status: true, type: 'searchResults' },
      });
    }

    //OBTIENE EL STATUS DEL BOTON DE REPRODUCCION
    dispatch(
      getMCSPlayButtonList(predictiveResponse?.response?.contenidos, token),
    );

    //SI TIENE BOOKMARK LO AGREGA EN LA RESPUESTA DEL CONTENIDO
    let searchResults;

    if (user_hash) {
      searchResults = await getBookmarks({
        contenidos: predictiveResponse?.response?.contenidos,
        user_hash,
        filterlist,
        lasttouch: localStorage.getItem('lasttouchSeen'),
      });
    } else {
      searchResults = predictiveResponse?.response?.contenidos;
    }

    //SI SE ENCUENTRAN RESULTADOS
    dispatch({
      type: GET_SEARCH_RESULTS,
      payload: {
        searchResults,
        talents: predictiveResponse?.response?.talentos,
      },
    });
    dispatch(setErrorLinealPredictive([]));
    dispatch({
      type: IS_LOADING_SEARCH,
      payload: false,
    });
  } catch (error) {
    console.log(error?.response);
    dispatch({
      type: NOT_FOUND_SEARCH_RESULTS,
      payload: { status: true, type: 'failureService' },
    });
    dispatch({
      type: IS_LOADING_SEARCH,
      payload: false,
    });
        //SETEAR EL ERROR
        if (error?.response?.data?.errors?.length > 0) {
          dispatch(setErrorLinealPredictive(error?.response?.data?.errors));
        }
  }
};

//----Obtiene las busquedas populares----
export const getPopularSearches = popularValues => async dispatch => {
  const {
    user_hash,
    filterlist,
    token,
    epg_version,
    quantity,
    is_kids,
  } = popularValues;

  try {
    const { data: popularResponse } = await api.get('services/list/ranking', {
      params: {
        api_version: 'v5.93',
        quantity: quantity,
        epg_version,
        is_kids,
      },
    });

    //OBTIENE EL STATUS DEL BOTON DE REPRODUCCION
    dispatch(
      getPlayButtonListPopularSearches(
        popularResponse?.response?.groups,
        token,
      ),
    );
    //SI TIENE BOOKMARK LO AGREGA EN LA RESPUESTA DEL CONTENIDO
    let popularResults;
    if (user_hash) {
      popularResults = await getBookmarks({
        contenidos: popularResponse?.response?.groups,
        user_hash,
        filterlist,
        lasttouch: localStorage.getItem('lasttouchSeen'),
      });
    } else {
      popularResults = popularResponse?.response?.groups;
    }

    //SI ENCUENTRA BUSQUEDAS POPULARES
    dispatch({
      type: GET_POPULAR_SEARCHES,
      payload: popularResults,
    });
    localStorage.setItem(
      'popularSearchesSaved',
      JSON.stringify(popularResults),
    );
  } catch (error) {
    console.log(error, 'POPULAR');
    if (localStorage.getItem('popularSearchesSaved')) {
      return dispatch({
        type: GET_POPULAR_SEARCHES,
        payload: JSON.parse(localStorage.getItem('popularSearchesSaved')),
      });
    }
    dispatch({
      type: NOT_FOUND_SEARCH_RESULTS,
      payload: { status: true, type: 'failureService' },
    });
  }
};

//----Agrega bookmark a evento que esta siendo transmitido----
export const addLiveBookmark = bookmarkInfo => dispatch => {
  dispatch({
    type: SEARCH_ADD_BOOKMARK_LIVE,
    payload: bookmarkInfo,
  });
};

//Agrega los valores de evento y canal para abrir el menu live
export const setLiveMenuOptions = payload => dispatch => {
  dispatch({
    type: SET_LIVE_MENU_OPTIONS,
    payload,
  });
};

//Purga los valores de la configuracion para abrir el menu live
export const clearSearchLiveConfig = () => dispatch => {
  dispatch({
    type: SEARCH_CLEAR_LIVE_MENU_OPTIONS,
  });
};
//Setear el keyword que se ingresa para acceder a un contenido VOD, live
export const setKeywordSearch = payload => dispatch => {
  dispatch({
    type: SET_KEYWORD_SEARCH,
    payload,
  });
};
//Limpiar el valor de la keyword
export const clearKeywordSearch = () => dispatch => {
  dispatch({
    type: CLEAR_KEYWORD_SEARCH,
  });
};

//----Agrega bookmark a evento que esta siendo transmitido POPULAR----
export const addLiveBookmarkPopular = bookmarkInfo => dispatch => {
  dispatch({
    type: POPULAR_ADD_BOOKMARK_LIVE,
    payload: bookmarkInfo,
  });
};

//Setear los errores de linealpredictive para kid
export const setErrorLinealPredictive = searchErrors => dispatch => {
  dispatch({
    type: SET_ERROR_SEARCH,
    payload: searchErrors,
  });
};
